import React, { Component } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { connect } from "react-redux";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import { getBillboardAction } from "store/Home";
// import Swiper core and required modules
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper/core";
import banner1 from "views/home/img/banner2.png";
// install Swiper modules
SwiperCore.use([EffectFade, Navigation, Pagination]);

class BannerClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBillBoardLoaded: 0,
    };
  }
  // async componentDidMount() {

  //   if(this.props.Auth.MG_TOKEN?this.props.Auth.MG_TOKEN.Data.token:""!=""){
  //     let response = await this.props.getBillboardAction();
  //     this.setState({isBillBoardLoaded:1})
  //     console.log(this.props.billboard)
  //   }else{
  //     this.setState({isBillBoardLoaded:0})
  //   }
  //    console.log("hmm")

  //   }
  // async componentDidCatch() {

  //   if(this.props.Auth.MG_TOKEN?this.props.Auth.MG_TOKEN.Data.token:""!=""){
  //     let response = await this.props.getBillboardAction();
  //     this.setState({isBillBoardLoaded:1})
  //     console.log(this.props.billboard)
  //   }else{
  //     this.setState({isBillBoardLoaded:0})
  //   }
  //    console.log("hmm")

  //   }
  render() {
    return (
      <>
        <Swiper
          spaceBetween={30}
          effect={"fade"}
          navigation={false}
          pagination={{
            clickable: true,
          }}
          className="mySwiper"
        >
          <SwiperSlide className="relative ">
            <img
              src={banner1}
              className="w-full bannerslider-img"
              alt="banner-img "
            />

            <div className="inside-text text-left absolute ">
              <h1 className="text-banner-2  font-semibold "></h1>
              <p className="text262626  sm-fsize12 fsize18  line-h26px sm-line-h20px w-3/4">
                Vacancy available for Phone Banking Officer.Apply now!
              </p>

              <button className="cust-apply-btn flex">APPLY NOW</button>
            </div>
          </SwiperSlide>
          {this.props.billboard && this.props.billboard.Data
            ? this.props.billboard.Data.map((value, index) => {
                return (
                  <SwiperSlide className="relative " key={index}>
                    {value.b_type === "video" ? (
                      <video
                        controls
                        className="w-full rounded-t-15px max-h-641vh sm-194px bg-black"
                      >
                        <source
                          src={
                            process.env.REACT_APP_IMAGE_BASE_MG + value.b_path
                          }
                          className="w-full rounded-t-15px "
                          type="video/mp4"
                        />

                        <source
                          src={
                            process.env.REACT_APP_IMAGE_BASE_MG + value.b_path
                          }
                          className="w-full rounded-t-15px"
                          type="video/ogg"
                        />
                      </video>
                    ) : (
                      <img
                        src={process.env.REACT_APP_IMAGE_BASE_MG + value.b_path}
                        className="w-full bannerslider-img"
                        alt="banner-img "
                      />
                    )}

                    <div className="inside-text absolute">
                      <h1 className="text-banner-2 font-semibold " style={{background:value.b_buttonColor||"#262626"}}>
                        {value.b_title}
                      </h1>
                      {/* <p className="text-black fsize18 text-left">
                        Phone Banking Officer.Apply now!
                        <br />
                      </p> */}

                      <button className="cust-apply-btn flex" style={{background:value.b_buttonColor||"#e77817"}}>
                        {value.b_buttonText||"Explore"}{" "}
                      </button>
                    </div>
                  </SwiperSlide>
                );
              })
            : ""}
          {/* <SwiperSlide className="relative ">
          <img
            src={banner2}
            className="w-full bannerslider-img"
            alt="banner-img "
          />

          <div className="inside-text absolute">
            <h1 className="text-banner-2 font-semibold ">
              Phone Banking Officer
            </h1>
            <p className="text-black fsize18 text-left">
              Vacancy available for Phone Banking <br />
              Officer.Apply now!
            </p>

            <button className="cust-apply-btn flex">APPLY NOW</button>
          </div>
        </SwiperSlide> */}
        </Swiper>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    billboard: state.Home.home.BILLBOARD,
    Auth: state.Auth.user,
    // dashboard: state.dashboard.dashboard,
    // document: state.document.document,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getBillboardAction: async () => await dispatch(getBillboardAction()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BannerClass);
